import { useEffect, useState } from 'react';
import { formatUtcClock } from '../lib/time';

/** The current UTC time as "14:32". Re-renders only when the minute changes. */
export function useUtcClock(): string {
  const [clock, setClock] = useState(() => formatUtcClock(new Date()));
  useEffect(() => {
    const timer = window.setInterval(() => setClock(formatUtcClock(new Date())), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return clock;
}
